import axios from 'axios';
export const checkPermission = async (rbacApiRoot, permission, principal, wallet, currentScopes, requiredScope) => requiredScope !== undefined && currentScopes !== undefined && currentScopes.indexOf(requiredScope) !== -1
    ? true
    : axios
        .get(`${rbacApiRoot}/authorize`, {
        params: {
            permission: permission,
            principal: principal.value,
            principalType: principal.type,
            wallet: wallet,
        },
    })
        .then(() => true)
        .catch(async (e) => (e.response.status === 403 ? false : Promise.reject(e)));
export const createOrganization = async (rbacApiRoot, input, authToken) => axios
    .post(`${rbacApiRoot}/organization`, input, { headers: { Authorization: authToken.value() } })
    .then((response) => response.data)
    .then((data) => ({
    wallet: data.wallet,
}));
export const updateOrganizationName = async (rbacApiRoot, wallet, input, authToken) => axios
    .post(`${rbacApiRoot}/organization/${wallet}`, input, { headers: { Authorization: authToken.value() } })
    .then((response) => response.status === 200);
export const updateOrganizationProfile = async (rbacApiRoot, wallet, input, authToken) => axios
    .put(`${rbacApiRoot}/organization/${wallet}/profile`, input, { headers: { Authorization: authToken.value() } })
    .then((response) => response.status === 200);
export const inviteMember = async (rbacApiRoot, input, authToken) => axios
    .put(`${rbacApiRoot}/organization/${input.wallet}/member/${input.memberEmail}`, { role: input.newRole, lang: input.lang, signer: input.signer }, { headers: { Authorization: authToken.value() } })
    .then((response) => response.data);
export const updateMember = async (rbacApiRoot, input, authToken) => axios
    .post(`${rbacApiRoot}/organization/${input.wallet}/member/${input.memberEmail}`, { role: input.newRole, signer: input.signer }, { headers: { Authorization: authToken.value() } })
    .then((response) => response.data);
export const deleteMember = async (rbacApiRoot, input, authToken) => axios
    .delete(`${rbacApiRoot}/organization/${input.wallet}/member/${input.memberId}`, {
    headers: { Authorization: authToken.value() },
})
    .then((response) => response.data);
export const listAllOrganizations = async (rbacApiRoot, pageLimit, cursor, wallet, createdBy, token) => axios
    .get(`${rbacApiRoot}/organization/all`, {
    params: {
        pageLimit: pageLimit,
        cursor: cursor,
        ...(wallet ? { wallet: wallet } : {}),
        ...(createdBy ? { createdBy: createdBy } : {}),
    },
    headers: { authorization: token.value() },
})
    .then((output) => output.data);
export const organizationMembers = async (rbacApiRoot, wallet, token) => axios
    .get(`${rbacApiRoot}/organization/${wallet}/member`, {
    headers: { authorization: token.value() },
})
    .then((output) => output.data);
export const permissions = {
    //RBAC
    postOrganization: 'rbac:post:organization',
    putOrganization: 'rbac:put:organization',
    deleteOrganizationMember: 'rbac:delete:organization-member',
    putOrganizationMember: 'rbac:put:organization-member',
    postOrganizationMember: 'rbac:post:organization-member',
    getOrganizationMemberList: 'rbac:get:organization-member-list',
    getOrganizationRole: 'rbac:post:organization-role',
    getOrganization: 'rbac:get:organization',
    //MINTER
    postSign: 'minter:post:sign',
    postRequestApproval: 'minter:post:request-approval',
    postRequestApprovalWithSignatures: 'minter:post:request-approval-with-signatures',
    abortCertificate: 'minter:abort:certificate',
    abortOwnCertificate: 'minter:abort:own-certificate',
    postCertificate: 'minter:post:certificate',
    postCertificateResendEmail: 'minter:post:certificate-resend-email',
    postCertificateResendApprovalRequest: 'minter:post:certificate-resend-approval-request',
    getCertificateDetails: 'minter:get:details',
    getCertificateList: 'minter:get:certificate-list',
    getCertificateCount: 'minter:get:certificate-count',
    getCertificateSimilar: 'minter:get:certificate-similar',
    getCertificateDownload: 'minter:get:certificate-download',
    getCredits: 'minter:get:credits',
    validateRender: 'minter:post:validate-render',
    registerOrRejectSignature: 'minter:post:register-or-reject-signature',
    approveChangeRequest: 'minter:patch:certificate-change-request',
    rejectChangeRequest: 'minter:delete:certificate-change-request',
    //API-KEYS
    getApiKeyList: 'api-keys:get:list',
    postApiKey: 'api-keys:post',
    deleteApiKey: 'api-keys:delete',
    //TEMPLATE-MANAGER
    readTemplate: 'template-manager:read',
    writeTemplate: 'template-manager:writeTemplate',
    //CUSTODIAN
    postCustodianSign: 'custodian:post:sign',
    postCustodianCreateSignature: 'custodian:post:createSignature',
    //PAGES
    getPageDetails: 'pages:getDetails',
    listPages: 'pages:list',
    createPage: 'pages:create',
    updatePage: 'pages:update',
    deletePage: 'pages:delete',
    uploadAssetToPage: 'pages:upload-asset',
    getLeadsFeature: 'pages:get:leads',
    getPageAnalyticsFeature: 'pages:get:analytics',
    getPageMetrics: 'pages:get:metrics',
    //LEARNING-ROUTES
    deleteLearningRoute: 'learning-routes:delete',
    getLearningRouteDetails: 'learning-routes:getDetails',
    listLearningRoute: 'learning-routes:list',
    createLearningRoute: 'learning-routes:create',
    updateLearningRoute: 'learning-routes:update',
    //WEBHOOKS
    getWebhookList: 'webhooks:get:list',
    postWebhook: 'webhooks:post',
    testWebhook: 'webhooks:test',
    deleteWebhook: 'webhooks:delete',
    //NOTIFIER
    createBrand: 'notifier:createBrand',
    getBrand: 'notifier:getBrand',
    /**
     * @deprecated use putSettings
     */
    createSenderSettings: 'notifier:createSenderSettings',
    /**
     * @deprecated use getSettings
     */
    getSenderSettings: 'notifier:getSenderSettings',
    putSettings: 'notifier:put:settings',
    getSettings: 'notifier:get:settings',
    putMailCustomization: 'notifier:put:mailCustomization',
    getMailCustomization: 'notifier:get:mailCustomization',
    listMailCustomizations: 'notifier:get:mailCustomizations',
    deleteMailCustomization: 'notifier:delete:mailCustomization',
    enableMailCustomizationFeature: 'notifier:post:mailCustomizationFeatureEnabled',
    testEmail: 'notifier:testEmail',
    getCustomEmailProvider: 'notifier:getCustomEmailProvider',
    setMailerSettings: 'notifier:setMailerSettings',
    //IMAGE-STORE
    uploadOrganizationAsset: 'image-store:write:attachment',
    //CERTIFICATE-REQUEST-MANAGER
    postBulkDefinition: 'certificate-request-manager:post:bulk-definition',
    startBulkDefinition: 'certificate-request-manager:post:bulk-definition-start',
    putBulkAsset: 'certificate-request-manager:put:bulk-asset',
    listBulkDefinitions: 'certificate-request-manager:get:list-bulk-definitions',
    listBulkElements: 'certificate-request-manager:get:list-bulk-elements',
    submitBulkDefinition: 'certificate-request-manager:post:bulk-definition-submit',
    deleteBulkDefinition: 'certificate-request-manager:delete:bulk-definition',
    getBulkDefinition: 'certificate-request-manager:get:bulk-definition',
    //TRANSLATION-BRIDGE
    postTranslationRequest: 'translation-bridge:post:translation-request',
    //EMPLEABILITY
    readEmployabilityDetails: 'employability:read-employability-details',
    //CUSTOM-DOMAINS
    getCustomDomain: 'custom-domain:get:domain',
};
export const listMyOrganizationsByEmail = async (rbacApiRoot, email, authToken) => axios
    .get(`${rbacApiRoot}/organization`, {
    params: { email: email },
    headers: { authorization: authToken.value() },
})
    .then((output) => output.data);
export const listMyOrganizations = async (rbacApiRoot, token) => axios
    .get(`${rbacApiRoot}/organization`, {
    headers: { authorization: token.value() },
})
    .then((output) => output.data);
export const getOrganization = async (rbacApiRoot, organizationId) => axios.get(`${rbacApiRoot}/organization/${organizationId}`).then((response) => response.data);
export class RbacUrlBuilder {
    rbacRootApi;
    constructor(rbacRootApi) {
        this.rbacRootApi = rbacRootApi;
    }
    getOrganizationUrl(organizationId) {
        return `${this.rbacRootApi}/organization/${organizationId}`;
    }
}
export var ROLE_ID;
(function (ROLE_ID) {
    ROLE_ID["ADMIN"] = "ADMIN";
    ROLE_ID["OPERATOR"] = "OPERATOR";
    ROLE_ID["READ_ONLY"] = "READ_ONLY";
})(ROLE_ID || (ROLE_ID = {}));
export const getMyOrganization = async (rbacApiRoot, organizationId, authToken) => axios
    .get(`${rbacApiRoot}/organization/${organizationId}/me`, {
    headers: {
        Authorization: authToken.value(),
    },
})
    .then((response) => response.data);
//# sourceMappingURL=index.js.map